// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simplebar-offset li {
  font-family: 'Spoqa Han Sans Neo';
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  /* identical to box height */

  /* display: flex; */
  align-items: center;
  letter-spacing: 0.2px;
  color: #444444;

  /* Inside auto layout */
  flex: none;
  order: 0;
  flex-grow: 0;
}

.simplebar-content {
  font-family: 'Spoqa Han Sans Neo';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  /* identical to box height */

  /* display: flex; */
  align-items: center;
  letter-spacing: 0.2px;
  color: #444444;

  /* Inside auto layout */
  flex: none;
  order: 0;
  flex-grow: 0;
}

.simplebar-offset a:hover {
  color: #2e56a3 !important;
}

.simplebar-offset .active:hover {
  color: #ffffff !important;
}

.simplebar-offset .active {
  background-color: #2e56a3 !important;
  color: #ffffff !important;
  border-radius: 0px 30px 30px 0px !important;
}

.pagination .active span {
  background-color: #2e56a3 !important;
  color: #ffffff !important;
}

.simplebar-offset li.nav-group ul li {
  font-family: 'Spoqa Han Sans Neo';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;

  display: flex;
  align-items: center;
  letter-spacing: 0.2px;

  color: #666666;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}

.btn.bg-white {
  background-color: white !important;
  color: #2e56a3 !important;
}
.btn.bg-white:hover {
  background-color: #2e56a3 !important;
  color: #fff !important;
}
.btn.bg-white.no-hover:hover {
  background-color: white !important;
  color: #2e56a3 !important;
}

.btn.bg-white-warn {
  background-color: white !important;
  color: #c90e0e !important;
}
.btn.bg-white-warn:hover {
  background-color: #c90e0e !important;
  color: #fff !important;
}

.btn.bg-white-disabled {
  background-color: white !important;
  color: #8a8a8a !important;
}
.btn.bg-white-disabled:hover {
  background-color: #8a8a8a !important;
  color: #fff !important;
}

.btn.text-bg-none {
  background-color: transparent !important;
  box-shadow: none !important;
}

.form-control input[type='text'] {
  border-radius: 5px !important;
  border: 1px solid #e2e2e2 !important;
}
.form-control input[type='password'] {
  border-radius: 5px !important;
  border: 1px solid #e2e2e2 !important;
}
.form-control textarea {
  padding: 10px;
  width: 98%;
  border-radius: 5px !important;
  border: 1px solid #e2e2e2 !important;
}

.sales {
  display: inline-block;
  position: absolute !important;
  margin-top: 10px;
}

.breadcrumb-item.active {
  font-family: 'Spoqa Han Sans Neo';
  font-style: normal;

  font-size: 14px;

  display: flex;
  align-items: center;
  letter-spacing: 0.2px;
  color: #fff;
}

.breadcrumb-item a {
  font-family: 'Spoqa Han Sans Neo';
  font-style: normal;

  font-size: 14px;

  display: flex;
  align-items: center;
  letter-spacing: 0.2px;
  color: #fff;
}

.wrap-vertical::-webkit-scrollbar {
  display: none;
}

/* .swiper-container {
  width: 100%;
  padding-top: 50px;
  padding-bottom: 50px;
  background-color: transparent;
} */

.swiper-image {
  height: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.swiper-image img {
  display: block;
  max-height: 80%;
  max-width: 90%;
}

.swiper .pagination {
  position: absolute;
  bottom: 10px !important;
}
.swiper .swiper-pagination-bullet {
  background-color: #000;
  margin: 0 10px !important;
}

.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

/* 카드사 셀렉트 박스 */
.pgCoprSelect-block {
  display: block;
  width: 100%;
  padding: 0 0.75rem;
}

.pgCoprSelect-block > button {
  width: 98%;
  margin: 0 !important;
}

.pgCoprSelect-block > ul {
  width: 90%;
  margin: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;;EAE5B,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;;EAEd,uBAAuB;EACvB,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;;EAE5B,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;;EAEd,uBAAuB;EACvB,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;;EAEf,aAAa;EACb,mBAAmB;EACnB,qBAAqB;;EAErB,cAAc;;EAEd,uBAAuB;;EAEvB,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;AACA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;AACA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;AACA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;AACA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;EACE,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,UAAU;EACV,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;;EAElB,eAAe;;EAEf,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;;EAElB,eAAe;;EAEf,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;GAKG;;AAEH;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,eAAe;AACf;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB","sourcesContent":[".simplebar-offset li {\n  font-family: 'Spoqa Han Sans Neo';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 15px;\n  line-height: 18px;\n  /* identical to box height */\n\n  /* display: flex; */\n  align-items: center;\n  letter-spacing: 0.2px;\n  color: #444444;\n\n  /* Inside auto layout */\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n}\n\n.simplebar-content {\n  font-family: 'Spoqa Han Sans Neo';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 15px;\n  /* identical to box height */\n\n  /* display: flex; */\n  align-items: center;\n  letter-spacing: 0.2px;\n  color: #444444;\n\n  /* Inside auto layout */\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n}\n\n.simplebar-offset a:hover {\n  color: #2e56a3 !important;\n}\n\n.simplebar-offset .active:hover {\n  color: #ffffff !important;\n}\n\n.simplebar-offset .active {\n  background-color: #2e56a3 !important;\n  color: #ffffff !important;\n  border-radius: 0px 30px 30px 0px !important;\n}\n\n.pagination .active span {\n  background-color: #2e56a3 !important;\n  color: #ffffff !important;\n}\n\n.simplebar-offset li.nav-group ul li {\n  font-family: 'Spoqa Han Sans Neo';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n\n  display: flex;\n  align-items: center;\n  letter-spacing: 0.2px;\n\n  color: #666666;\n\n  /* Inside auto layout */\n\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n}\n\n.btn.bg-white {\n  background-color: white !important;\n  color: #2e56a3 !important;\n}\n.btn.bg-white:hover {\n  background-color: #2e56a3 !important;\n  color: #fff !important;\n}\n.btn.bg-white.no-hover:hover {\n  background-color: white !important;\n  color: #2e56a3 !important;\n}\n\n.btn.bg-white-warn {\n  background-color: white !important;\n  color: #c90e0e !important;\n}\n.btn.bg-white-warn:hover {\n  background-color: #c90e0e !important;\n  color: #fff !important;\n}\n\n.btn.bg-white-disabled {\n  background-color: white !important;\n  color: #8a8a8a !important;\n}\n.btn.bg-white-disabled:hover {\n  background-color: #8a8a8a !important;\n  color: #fff !important;\n}\n\n.btn.text-bg-none {\n  background-color: transparent !important;\n  box-shadow: none !important;\n}\n\n.form-control input[type='text'] {\n  border-radius: 5px !important;\n  border: 1px solid #e2e2e2 !important;\n}\n.form-control input[type='password'] {\n  border-radius: 5px !important;\n  border: 1px solid #e2e2e2 !important;\n}\n.form-control textarea {\n  padding: 10px;\n  width: 98%;\n  border-radius: 5px !important;\n  border: 1px solid #e2e2e2 !important;\n}\n\n.sales {\n  display: inline-block;\n  position: absolute !important;\n  margin-top: 10px;\n}\n\n.breadcrumb-item.active {\n  font-family: 'Spoqa Han Sans Neo';\n  font-style: normal;\n\n  font-size: 14px;\n\n  display: flex;\n  align-items: center;\n  letter-spacing: 0.2px;\n  color: #fff;\n}\n\n.breadcrumb-item a {\n  font-family: 'Spoqa Han Sans Neo';\n  font-style: normal;\n\n  font-size: 14px;\n\n  display: flex;\n  align-items: center;\n  letter-spacing: 0.2px;\n  color: #fff;\n}\n\n.wrap-vertical::-webkit-scrollbar {\n  display: none;\n}\n\n/* .swiper-container {\n  width: 100%;\n  padding-top: 50px;\n  padding-bottom: 50px;\n  background-color: transparent;\n} */\n\n.swiper-image {\n  height: 90%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.swiper-image img {\n  display: block;\n  max-height: 80%;\n  max-width: 90%;\n}\n\n.swiper .pagination {\n  position: absolute;\n  bottom: 10px !important;\n}\n.swiper .swiper-pagination-bullet {\n  background-color: #000;\n  margin: 0 10px !important;\n}\n\n.spinner-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n\n/* 카드사 셀렉트 박스 */\n.pgCoprSelect-block {\n  display: block;\n  width: 100%;\n  padding: 0 0.75rem;\n}\n\n.pgCoprSelect-block > button {\n  width: 98%;\n  margin: 0 !important;\n}\n\n.pgCoprSelect-block > ul {\n  width: 90%;\n  margin: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
